import z from "zod";
export const SystemPrincipal = { type: 'system', _id: 'system' };
;
export const ClientAppType = z.enum(['webApp', 'desktopTransferApp']);
/**
 * Arbitrary line
 */
export const FrameAnnotationPath = z.object({
    type: z.literal('path'),
    id: z.string().min(1),
    strokeColor: z.string().min(1),
    strokeWidth: z.number().positive(),
    /**
     * A flattened array of x, y coordinate pairs.
     * Every 2n-th item is an x coordinate and every 2n+1-th item is a y coordinate.
     */
    points: z.array(z.number())
});
export const FrameAnnotationCircle = z.object({
    type: z.literal("circle"),
    id: z.string().min(1),
    strokeColor: z.string().min(1),
    strokeWidth: z.number().positive(),
    x: z.number(),
    y: z.number(),
    radius: z.number()
});
export const FrameAnnotationRect = z.object({
    type: z.literal("rect"),
    id: z.string().min(1),
    strokeColor: z.string().min(1),
    strokeWidth: z.number().positive(),
    /**
     * x coordinate of the top-left corner
     */
    x: z.number(),
    /**
     * y coordinate of the top-left corner
     */
    y: z.number(),
    width: z.number(),
    height: z.number(),
    cornerRadius: z.number()
});
/**
 * Straighe line
 */
export const FrameAnnotationLine = z.object({
    type: z.literal("line"),
    id: z.string().min(1),
    strokeColor: z.string().min(1),
    strokeWidth: z.number().positive(),
    x1: z.number(),
    y1: z.number(),
    x2: z.number(),
    y2: z.number()
});
export const FrameAnnotationText = z.object({
    type: z.literal("text"),
    id: z.string().min(1),
    color: z.string().min(1),
    backgroundColor: z.string().optional(),
    x: z.number(),
    y: z.number(),
    width: z.number(),
    fontFamily: z.string(),
    fontSize: z.number(),
    lineHeight: z.number(),
    fontStyle: z.enum(['normal', 'bold']).optional(),
    text: z.string()
});
export const FrameAnnotationShape = z.union([FrameAnnotationCircle, FrameAnnotationPath, FrameAnnotationRect, FrameAnnotationLine, FrameAnnotationText]);
export const FrameAnnotationCollection = z.object({
    width: z.number().positive(),
    height: z.number().positive().optional(),
    annotations: z.array(FrameAnnotationShape)
});
//# sourceMappingURL=models.js.map